export const publicRoute = [
  "/login",
  "/signup",
  "/confirm-signup",
  "/forgot-password",
];
